import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TCHCompatibleLoadersFields,
  TCHCompatibleLoadersProps,
  TCHCompatibleLoadersTab,
} from '../types/productCompatibleLoaderListing.types';
import { StringField } from '../../../types/types';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';

export class ProductCompatibleLoaderListingModel {
  private readonly fields: TCHCompatibleLoadersFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TCHCompatibleLoadersProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): StringField {
    return { value: this.fields?.apiData?.title };
  }

  get eyebrow(): StringField {
    return { value: this.fields?.apiData?.eyebrow };
  }

  get description(): StringField {
    return { value: appendRootToRichTextInternalLinks(this.fields?.apiData?.description) };
  }

  get tabs(): TCHCompatibleLoadersTab[] {
    return this.fields?.apiData?.items || [];
  }

  get expandLabel(): string {
    return this.fields?.apiData?.['expand-label'];
  }

  get baseUrl(): string {
    return this.fields?.itemData?.fields?.productsItemUrl ?? '';
  }

  get templateName(): string {
    if (this.rendering?.componentName?.toLowerCase().includes('attachment')) {
      return 'Compatible Attachments';
    } else {
      return 'Compatible Loaders';
    }
  }
}
